// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  adminEnterprises: '3dfdaccceebde8172b816649d9cd7d32',
  adminPools: '6a954585b747f57b5f4ec3209d78c3c3',
  adminProjectDescriptionUpdate: '80ee25c3b348b35337a81bdc97c2086c',
  adminUserDocumentSubmissions: 'cb1b10f0d8e2e56f6144bcfa8b15996a',
  adminUserEnterprises: '1cc08fb4667b5ab1271bb25872c03af1',
  adminUserPools: '1348e6e46173a87cc6d1978af799b063',
  adminUserVerificationProcesses: 'e50fdc5ba76285148b95908f9845b5a3',
  adminVerificationProcessTypes: '2c775d17e3c24746c1f1cac290962d7a',
  agentSessions: 'c8a80dabcd674d81cb73df88db523b93',
  agents: '77cc0d0971e66d6fcbfc5a9f90c12abf',
  allProjects: 'e4273d1a4de8b49a08ec4716463021e7',
  analytics: '65bf58a4853e795beec7656aac5f226a',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: '1c7a8f59393a31290c65a57def365ce5',
  banners: '4ce9d48fe0d6cf8bf31ccf8fabeeea66',
  bidAwardDrafts: '4bdb7e717a8ce7e339b808ccfcc39e7b',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidDescription: 'ff1f74cce36f7f4611303437ac38a532',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidPitch: 'f38640454a19287e90d35a550db33dec',
  bidRestrictions: '8e57d9d74cbda29d6a0ea8563da5c404',
  bidScores: 'abf7389f299ca35ca24fca88c223b2d4',
  bidSummaries: '7d5ace0b55b64e31fa94713422e25ab0',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  bids: '76fd6e83ebb6ce69a704e801fed3a10e',
  billingAgreements: 'effc51be56168965461e32b1afdc844e',
  campaigns: 'e9b8b0accb91cf9eb0f204cb95ffd0be',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  cartApprovals: '144b1843c9c5213201fe9238928f6d78',
  cartItems: 'a7ac584a5626dc5c4cc69d7387955bac',
  carts: 'd031ad6617e27ded717a92b6f9fae0d3',
  categoryPageContent: '6735adbf5cff37e855b1056ebf374d8f',
  categoryPageViewUsers: 'e26d371c5adf550d6a9a9018e2fc2964',
  certifications: '43fd8862311f73a91a22f2e897799065',
  commentFeeds: '9d3ed3fe095086fe6682665c37d5263f',
  comments: '9f59b77ecd01881bd5a02f93caf963aa',
  contacts: 'e23a0ac1dc1518756cfb30c8d8b2f52b',
  contentCustomization: '16eaf3f12687da31f35d914eb8aa3335',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestCollaborations: 'dbe3b1d3eb3e6c8749f8c876ed9a0606',
  contestComments: 'f7c0d794e15afbe67510057bab896401',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '51d116218f1a7f0dc626ec43adf4e1c7',
  contestEntryMessages: 'b651a46c42121f21107cd6c825133299',
  contestEntryOffers: '4b2413d572e0f8f8b616258e6ac8cc22',
  contestFees: '6960d7647ebf648222074b05fef547be',
  contestFiles: 'abe08370d1fcbb188064e2fc20abf5f7',
  contestHandovers: '9ac9b70b0f42d6f0f2f079df0e8437ce',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: '9e363880b10da1128e3a11f4087aa536',
  contestInvite: 'f06aea98eeae00234f7e734b108ba73c',
  contestMessages: '3f43e64e593e63315ac37fb06fe9fd4e',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestPolls: 'd6f47e4b8b7db7c84efa7e82ce0a5b70',
  contestQuickviewEntries: '754bf9eb1014fb08d1b39d540e1d0749',
  contestRubricSubmissions: '7cc35149f4da347798ebf365c77740a9',
  contestRubrics: 'd88b55b6d86877e1c21340e46ee86361',
  contestViewContests: '0dae0e6ff8200b072041523d03af0216',
  contestViewEntries: '07a46e2d28303abc31ab02763392d8a6',
  contestViewEntryIds: 'b158579a32ef41f4fb784ab7959ef002',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  contestsSelfInsights: '6d4a26f1f9e583f35f315779173b83c0',
  contests: '3cb97310aedf009849db83a04b4c7cf2',
  contractDownloadUrls: '8f18f9bf00cb67d524029682cb9f3e5a',
  contractSigningUrls: '9531a561e722488c910f29e9d660046c',
  copilotChat: '53fb33dd8f95db2675e2dfc59b04a31f',
  copilotEnquiries: '237ebf3a39957f06cf20439b5bd40082',
  countries: 'd84355b6576cf5c6a700adf325033d34',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  currencyDetect: '7de9b2df5bf61db45209b0276ae15363',
  customFieldInfoConfigurations: '015fb49ced9e533d9437bb16bb9077e3',
  customFieldRelationships: '08cff63e947b4b3b9c257accf0749cf4',
  customFieldValidations: '4002de6cf50535356bda1d79b06398dc',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: 'd11e5c265791746db0e60e53fb660543',
  deleteCommentsByUser: '5223146cd937d2a4109cda2fc1969e94',
  deleteFeedsByUser: '4a3dc025737c4848233fb16848112ddc',
  deloitteSubscriberEmails: '2a956b3ce9896b790432b92033dcee4b',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '8bb0726943268b06e681380cd2d20082',
  depositPageVars: 'bae6c9fd5a5d513ca96b208249b64d14',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  developerTokens: 'ae77f04e1068b8e15782e70604eceda3',
  discoverCollectionItemSaveCount: 'ee3fb67e46172b6cb612295484893b81',
  discoverCollectionItems: '991e682da4aeb531fbe5cc5a74273808',
  discoverCollections: '52a491a41aee193d2846868905a1b30d',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '35b7f881fba5ea2784e30179c94622c8',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailLeadCapture: '7df8449a7c15a826e66557f13af0f4ee',
  employerReputationsRehireRates: '5fc9a744d2ba688513624a7529f6475e',
  encodedUrl: '44db17c46c57d7831b9e560e1613b31e',
  enterpriseBillingAgreementsBalance: '388804f8cb93db4aa1acfb33a03d7c72',
  enterpriseContact: 'f9f4efad2b2f6589c7041036526d80a5',
  enterpriseLoadshiftCancelGrandfatheredMembership:
    '8bf8f74068ccb1adc336b38cee4546e9',
  enterprises: '62aaf5c23e5f6081a98a7471b8e15e3e',
  equipmentGroup: 'cd34e9fda34ec9f3fb2d4734e387e2a4',
  equipment: '401a6e037ec2892bf5110d5e3795d3a8',
  exams: 'a490e8e606bf16f4f0f200c31d54e47f',
  exchangeRates: 'e3eddbf66ac9e18a5e4319e8a12f34ac',
  experiences: '40986fee31964385e45bc33aef538cf7',
  feedMeta: '74d315b8aed1552c1553ecd83a37408a',
  feedPosts: '2bed123d157ff013e8c05c4c0fbedfe8',
  feed: 'dd5c9063680ab247e9ebd4c97b74b7f5',
  feedback: '992692453e8a744e215e402b7464575c',
  fieldServicesTalent: '6812eafadad1e4e3692a188745ae2e41',
  findPageDetails: '69340ad72fb8a20425b87f886c500d16',
  freelancerReputationsRehireRates: '75d1b499c54de8e1e565862650651ea6',
  freelancerReputations: '2953da50cb7d09d13a1c3cbfc2543d19',
  globalFleetContact: 'bf1cb95f2ffd3b77a09962f62f2ffeab',
  grants: 'bb1d0a53382cc4e7b3342a23cbc34ed6',
  groupActions: '19fec4d55eabda7f893205ffd0daee59',
  groupAttachments: '44db5335e07d07a1c336502beda3d479',
  groupFeed: 'e2c6d28dc1cc0ba5198fa732a00238d1',
  groupMembers: '0774a673b3c90691fd3fe1566e8dc0a9',
  groupPermissions: 'f74fa869aebb39ea8facbd8688f872c7',
  groupsSelf: '6bc165345bb35b92538a874822fc8bc9',
  groups: '6bc165345bb35b92538a874822fc8bc9',
  hirePageDetails: 'fd166c2c221dc94ee4c45091bb7a739e',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  insightsBids: '276a49cd9bd766cd5a252ee5d337069c',
  invitationBlocks: '6a76355a8a942ecbba5b5c52ae56e575',
  invitations: '4c859a8d124a8e1f61e061f7808b6b12',
  invoices: '11248bfaa18fee68d253cba4ed83bb43',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  issuingInstitution: '191c5080a6cbb19009eb2935e758f46b',
  jobClassifier: '8d0cb74f449a0a11931133e83a9ad446',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  loadshiftSiteStats: '57aa1b2f6359704fda2e9a2dedf158ba',
  loginDevices: '3e1afdf4e5bf7fb5e73390edd4984dcd',
  manageViewContestHandovers: '9e292de1520bc107580012dfca558c09',
  manageViewContests: '73658c1dcba604e25a0fcf0898143e55',
  manageViewHandovers: '7f2e990b9cd16d1b98d88a3914a96df7',
  manageViewOngoingBids: '12f9cfe0cf7cf4a60dc8b94aa90e1f50',
  manageViewOngoingProjects: '2155764961ee104bcdc7063832bfd80b',
  manageViewOpenBids: '972809a1c4e167e8d1e4ee36604d7ad7',
  manageViewOpenProjects: 'a3d09a0e28f9a2357159b20662dcb7ec',
  manageViewPastBids: '3ddb0415a8a2d91995270bffc69a50d6',
  manageViewPastProjects: 'a2715b3ff61601d6ee40ec3a7b5d86ee',
  membershipBenefits: '1b3935953dfa7f6cad67f08a5e93380a',
  membershipDowngrades: '50b9485c910e81d92e1401e3ad1e5886',
  membershipPackagePrices: 'fa6e18fcf9dbc6654c1be4b8e3085d28',
  membershipPackages: '0593136eebe94e9ad4ebcdf6445e72e3',
  membershipRenewals: 'e357585dfa2f66ce9a1f79858a85bd95',
  membershipSale: '55fbeb62a6e565505a75dc3f9976634c',
  membershipSubscriptionHistory: 'cc453171cfe1fbe99a7e7d4bdc2089bd',
  membershipSubscription: 'e857bce84db7cabcdd1541e8b59d4c49',
  membershipTrials: 'ff61d0616faa339d81168e379fc03f70',
  messageAttachments: 'd7ca981c70df91f769a11e6c25cb52b6',
  messages: '59e924b92b2a62897f86398b5f91eb80',
  milestoneDrafts: 'f11b88854b984bd391b567b18c3af8ed',
  milestoneRequests: '840a5f69fca7f2a9e176ee34e3542069',
  milestones: '44e6ba8e6ec559a5ebc3517b3174bb2a',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  mygigsExpressionOfInterest: '91301a124c27f055daa04eae6179c50d',
  nativeExchangeRates: 'e3eddbf66ac9e18a5e4319e8a12f34ac',
  nearbyProjects: '7a4cca4f53eeccabb0aea8253192860d',
  newsfeed: '4d72283aa5c37f4c6239c6a92cfbb1cb',
  nextPreviousUsers: '84ead1aaa99dc711b4f7027f20a4ffc2',
  notificationSettings: 'f9f8604714c8832b680f2bbaff2b56bf',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  notifications: '87d9de4b5e2132f5004d545855ca516f',
  onBehalfProjects: '294c1b3eb27c70ea3916d1716fd7f28f',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  operatingAreas: '6315564555c3b367c2d274b2be650453',
  paymentShareInterests: '2dfbb50654bee0dfbfefdf174c53b594',
  paymentShareMembersSpendingDetails: '44105cc7ca131d371d85b9cda7435592',
  paymentShareMembersSpentAmount: '3464028ae93ed58778bd508875f70997',
  paymentShareMembers: 'df27633826da5d3e3026a0fad7e70358',
  paymentShareTeams: '164df671004b9dbd8f417ecd09436216',
  paymentShareWhitelistItems: '21b6c79935ff7da502a41309b33e4fd4',
  payoutAccountForm: '0f23629cc18d23b2624400d1fe1f73cc',
  payoutAccounts: '44eccf32823e257a3cbc88434132f4a5',
  payoutContext: 'b3f3d9edb2add040dc8eb5e21e7e34fc',
  payoutLimitExemptions: '3d274d832b852dc6acc98f06eb63002d',
  payoutMethods: '92f2004d858af89162952db738135e26',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pfpSkills: 'c385d285d53b8bf4d40fcaedf8affbb0',
  pfpStatus: '4f2c9e4711e1703f733844833d2476a2',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  pools: 'a11cd48cde19a8772346b9ed386cc890',
  portfolios: 'f799d42650b7c33019da0f98866b1c05',
  postFiles: 'b01b71a85aac504aa1e29bf639b2aeb3',
  postJobPageDescription: '94b98e17d9e054e5460c906bd0024662',
  postJobPageFormState: 'b6bcf829708570c7b9889eb4c7bc7a87',
  postJobPageQuestions: '2a6ab6f243ca7237e6d899e49fec9205',
  predefinedDiscoverCollections: '52a491a41aee193d2846868905a1b30d',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  preferredBillingAgreements: '446aa2c93d4e29ce86f185d558740548',
  profileCategories: '6e2e5dd8262e1e3a576a232c5d674ada',
  profileViewUsers: 'd93f20cf304171c9dd9372d068bcd033',
  projectBidInfo: '98f913e92f4370477da59576ab4a802a',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '7fee7f1d7ebd65b430377918a42ce486',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectFeedFailingContests: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeedFailingProjects: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectFeed: '88bc99dddd8b43cb90c6fef5d85e55ae',
  projectInvite: 'd88f62eaadcb2ebd35a51e815efbf160',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projectQualityDetails: 'e5dec7981b77b82b0dafc18d7a37774b',
  projectSpamControls: 'd6a17d28a2a784e04e545ff3802dc6ff',
  projectStats: '7113019a0689bd4be7a6ad023e02fe53',
  projectTitleEditRequest: 'dc4b523352a59b92007eb6a8beda687f',
  projectUpgradeFees: '0dfb153e40e347289a9e291d129716c4',
  projectViewBidderLocations: '4155ba632cbfefd6d6f756fe640dd3b5',
  projectViewBids: 'c91bad75fd7fb62bb70daa4f4cfa9e40',
  projectViewProjects: 'adf7b181aae5a896f3b8d50a1361da89',
  projectViewUsers: '70bf9b8ec31ecfaa6cf8b6b452c86ba0',
  projectsSelfInsights: '811ba7045bc5d3f1c9f6e70e58f0dfe3',
  projects: 'afe5e5b112f3937081ccce810ccbc185',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  quotationFundRequests: '4a0bc7d5c9e16816b1a2807cda19af7d',
  quotationFunds: '9de2e842f1c177afcdbc2a7cc0be74e0',
  quotationItemRevisions: 'e4ce1b5d6a7ad3128e8f945b916bba9e',
  quotationLogos: '2912f2c3e8f58b953986359c26789d34',
  quotationRevisions: '889579e7894b1afd94b5be7d00a3d215',
  quotationWhitelist: 'd5b9567e6615b0cfcfadf90db47c643c',
  reactionsTypeCount: '591546dbf80f9d3a5f986f8d7b35cca1',
  recentSavedSearchAlerts: '937bc55ddbcb405f091fd068189eb307',
  recommendedMembership: '136b2dc1686addd12e396cc73176828a',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  referralToken: '5c8adf6f78112fb9e94f52bf06a46532',
  reviewsSkills: '3ed5c1a7ee988dfeed7aceb5641ffebe',
  reviews: 'd6abcd627fc12bed95c02f201f632529',
  salesTax: '48b3aad4850275c7e718b9015e58561c',
  searchActiveContests: 'b1da1014f879f8117a15b3e6450e1c5d',
  searchActiveLoads: '7c5c40aa189427e1fdcc94add913ad02',
  searchActiveProjects: 'cd72693e92e592f4474c9ac20de575fa',
  searchAllProjects: 'afe5e5b112f3937081ccce810ccbc185',
  searchClosedContests: 'b1da1014f879f8117a15b3e6450e1c5d',
  searchContestEntrants: '16c81d21c56d0f1b5ec1929be770feae',
  searchContestEntries: '07a46e2d28303abc31ab02763392d8a6',
  searchFreelancers: '59790ae02045d1b1a8fcd4eb0284fd9d',
  searchKeywordProjects: '1f5af6a224fb12cd6c5bebf038916efe',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchProjectsSelf: 'e3cf76608cb456162809f92b333928f5',
  searchSavedFilters: 'd9ad82c6d8ccb7aae51f8046a8677624',
  searchThreads: '0f45ab94cd6a709ca37b56bad43f56ef',
  searchUsers: '09ae87155b472e9648310c1af1e65d2b',
  securityPhoneRequests: '524c1ee68465953f496b8cf1450d8bd6',
  semDynamicPageContent: '9f595bbcb56e0aee9b4d889c486a37b4',
  seoNavbar: '8e5b1dfa322833dc975cdeee75bbb014',
  serviceOfferings: '0c657cb9288f7bb1b93a99118ba2cb39',
  sessionResolveReasons: '4b8f01e81dffd10268e91df4378853a3',
  showcaseSource: 'e9d95438f258ffe530b4e2ef139e30ae',
  showcase: '3ac5c5476e5644e658956faaf1d3f857',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skillBundles: 'd00f17bc6add44c135e16d1641a0d65f',
  skillsSubNavigation: 'b53931bf59b48506b398c94c42f675a7',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  superuserAgentSessions: 'c8a80dabcd674d81cb73df88db523b93',
  superuserBids: '76fd6e83ebb6ce69a704e801fed3a10e',
  superuserGrants: 'bb1d0a53382cc4e7b3342a23cbc34ed6',
  superuserMessages: '59e924b92b2a62897f86398b5f91eb80',
  superuserMilestones: '44e6ba8e6ec559a5ebc3517b3174bb2a',
  superuserProjectCollaborations: '7fee7f1d7ebd65b430377918a42ce486',
  superuserProjectViewAllProjects: 'e4273d1a4de8b49a08ec4716463021e7',
  superuserProjectViewProjects: 'adf7b181aae5a896f3b8d50a1361da89',
  superuserProjectViewUsers: '0856fc90342e0faa24fe02c838dc71d7',
  superuserRoles: '24fd2c821b9b2a15d109a1cc18a69baf',
  superuserSearchThreads: '240a85aab023039eb802a0285d9abe7f',
  superuserThreads: '240a85aab023039eb802a0285d9abe7f',
  supportFeedbackIsAllowed: 'ec1a2ab220bf6ae718f3c31e2e96466b',
  supportFeedback: '0c8652b987faa5ed17604f4ade25657d',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  taskGroupMembers: '892902b8b45557eb39bc50e6c4d09079',
  taskGroupSection: '4f685d834c91aa4b2eebe5403d1287f6',
  taskGroup: 'd70cabd33ffacf61d789315b7d340290',
  tasks: '6bff96e4921ded6f44d7aa338d32502b',
  taxOptOutOptions: '8d79bd6dc2409d1834e732b384935a60',
  taxStatement: '5a6bd9efbc4eb9477d2b6da7c5b91fe3',
  tax: '269061e1c3f348f62dbd36fd55f74e0f',
  teamInvitations: '0f057884871c4cfb3058fa2c3b1054b6',
  teamMembers: '72012171395c87039424bc159d92f2e3',
  teams: '7fb269056325fb6d64b2a7ebe207fbad',
  threadProjects: '134991196b1d3dcdeb766fd8e41203a1',
  threads: '0f45ab94cd6a709ca37b56bad43f56ef',
  timeTrackingDailyAggregates: 'cf0b1a2d3b1818f710fd8b075d328e75',
  timeTrackingPunches: '978a2c023ab70576f2d3630e89ced002',
  timeTrackingSession: '80a6c6bc3554ed72d60b21f37512b918',
  timezones: 'e03b2867faa42e4a71b0c8dfe5ed2c0e',
  toastNotifications: 'f7ee96482da2b5470165b011b78279d3',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  userBalances: '19562fd91f748c6097966018189e5985',
  userBidLimit: '02e82788a8467ff18539b987ac7227b6',
  userBidOnRussianProjects: 'f799113d4a5ebf40db8efef7a9499eab',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userContestCollaborationWhitelist: '507680d8d3c0c2ea30ea86cb99166a55',
  userCustomEmails: 'c5a695af5ce03475ebd46ea02d521683',
  userDepositMethods: '032f9ac5ab0544e020e9781ce0059f4b',
  userDocumentSubmissions: 'cb1b10f0d8e2e56f6144bcfa8b15996a',
  userEmailRequest: '86011c5edfba0d2ee6d1c29ec86d7c01',
  userEnterprises: '1cc08fb4667b5ab1271bb25872c03af1',
  userFees: 'cc1806b6b645506e3cdfcf58c146f13d',
  userGiveGetDetails: '324dd4e90e17d808296a97dad8161472',
  userHasDuplicateIp: '3f2340a4213ed9be96b40660bfc2bad2',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: 'e8ae1bc08955551eae05a678f013f768',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userNotificationPreferences: '913e67ed3fde5f76c0326afc118ff616',
  userNps: '4cbf9dfa2ab3c351d16e8489d8977f8d',
  userParsedResumes: '432d95a91ea92debd3784e91a11a2b96',
  userPaymentControls: 'd4c613748f8b6fef5513faf94501bf5f',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userQualityDetails: '0dcc0040a73b7995229e380b160abcd6',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  userRequiresEmailVerification: 'e2f0beae240a0912172c652af0c3eb4e',
  userRequiresGdpr: '1f1923492a3b9ecbd2ce5b3c9c9d1b28',
  userRequiresPaymentVerification: '2c3c2819f099d4c23433dd0a56355caf',
  userRequiresPhoneVerification: '2ce7a52a3a029abb98242e9b00337ddb',
  userResumes: '1a461d39770bc29217ae80edd63736af',
  userSettings: 'c8c40643c75ce2a27bce2b2a0163b905',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTaxInfo: 'fee8d6d9e2e14d52eeb6012ef320e606',
  userTaxOptOutReasons: 'ce314c12bd90c530be886124e798b455',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  userVerificationProcesses: '69ef6d0e592c911c6275357dc8c18bc3',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: 'a05c972d91e02b4ad20f0d1611867cae',
  usersMfa: '6a39c996b736babac9262c3e7f5e7104',
  usersProfileImage: 'e97d332d6bb3ee806476de0483c34df7',
  usersProfile: '8c5484f3f9916b40c237b1a71eeb374f',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: '5ca393807df51b896a287bb1887f78ab',
  usersTeamProfile: '8c5484f3f9916b40c237b1a71eeb374f',
  users: 'd78776315852758223500a93e3755a2c',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationProcessTypes: '2c775d17e3c24746c1f1cac290962d7a',
  verificationRequest: 'f9366dfbb548d1eb4b03504af4bc6914',
  violationReports: 'a8481652e5feb67f53254e7d1b498be3',
  waitingScreenAnswersAfterBidSubmissions: '9e0c1f5c3aac57bdacf1eee1df3ba81b',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
